/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/contactPage.scss';

import React, {useEffect} from 'react';
import ContactFormController from "../contactFormController";
import {Helmet} from 'react-helmet';
import TextContainer from "../../textContainer/textContainer";
import {sendGaEvent, sendGaPageView} from '@dvrd/dvr-controls';
import {getImg, getImgSizes, getImgSources} from "../../../util/utils";

export default function ContactPage() {
    function onClickTel() {
        sendGaEvent('click', 'contact', 'tel-number');
    }

    function onClickEmail() {
        sendGaEvent('click', 'contact', 'email');
    }

    useEffect(() => {
        sendGaPageView('/contact');
    }, []);

    function renderContent() {
        return (
            <div className='contact-content'>
                <p>U kunt contact met mij opnemen door onderstaand contactformulier in te vullen. Ik ben ook
                    bereikbaar op <a href='tel:+31654716533' onClick={onClickTel}>06-54716533</a> (08:00 - 18:30,
                    bij voorkeur via Whatsapp) of via <a href='mailto:info@bowies.nl'
                                                         onClick={onClickEmail}>info@bowies.nl</a>. Telefonisch
                    kan ik niet altijd direct opnemen (onderweg of tijdens wandeling), ik zal u daarom zo spoedig
                    mogelijk terugbellen.</p>
                <img src={getImg('contact/leonique-veld-self-x480')}
                     srcSet={getImgSources('contact/leonique-veld-self', [300, 480])}
                     sizes={getImgSizes([300, 480], 480)} alt="Bowie's" className='img'/>
            </div>
        )
    }

    return (
        <div className='contact-page' id='contact'>
            <Helmet>
                <title>Bowie's | Contact</title>
                <link rel="canonical" href='https://bowies.nl/contact'/>
            </Helmet>
            <TextContainer invert title='Contact'>{renderContent()}</TextContainer>
            <div className='form-container'>
                <ContactFormController/>
            </div>
        </div>
    )
}